import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import api from "../../api";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const HourlyActiveIPsChart = () => {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });

  const [last1HrIPs, setLast1HrIPs] = useState(0);
  const [last12HrIPs, setLast12HrIPs] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token =
          localStorage.getItem("access_token") ||
          sessionStorage.getItem("access_token");

        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        const baseUrl = process.env.REACT_APP_API_URL;
        const res = await api.get(`${baseUrl}/chat/hourly-active-users`, config);

        // ✅ Match backend response structure
        const {
          data: {
            activeIPsInLast1Hour,
            activeIPsInLast12Hours,
            hourlyBreakdown,
          },
        } = res.data;

        const labels = hourlyBreakdown.map((item) => item.hour); // ["1Hr", "2Hr", ...]
        const data = hourlyBreakdown.map((item) => item.uniqueIPs); // [4, 2, 0, ...]

        setLast1HrIPs(activeIPsInLast1Hour);
        setLast12HrIPs(activeIPsInLast12Hours);

        setChartData({
          labels,
          datasets: [
            {
              label: "Active IPs",
              data,
              backgroundColor: "#6B6B6B",
              barThickness: 14,
              borderRadius: 2,
            },
          ],
        });
      } catch (err) {
        console.error("❌ Failed to fetch hourly active IPs:", err);
      }
    };

    fetchData();
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { mode: "index", intersect: false },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { font: { size: 12 } },
        title: {
          display: true,
          text: "Hour",
          font: { size: 13, weight: "bold" },
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          display: true,
          drawTicks: false,
          color: "#e0e0e0",
        },
        ticks: { display: false },
      },
    },
  };

  return (
    <div className="chart-card p-3 shadow-sm rounded profile-i mb-4">
      <div className="d-flex justify-content-between align-items-start mb-3">
        <h5 className="fw-semibold">
          <span className="border-start border-4 border-dark ps-2">
            Hourly Active IPs
          </span>
        </h5>
        <div className="text-end">
          <div className="d-flex gap-3">
            <div className="text-center">
              <div>IPs in last 1 hr</div>
              <div className="fw-bold">{last1HrIPs}</div>
            </div>
            <div className="vr" />
            <div className="text-center">
              <div>IPs in last 12 hr</div>
              <div className="fw-bold">{last12HrIPs}</div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ height: "300px", width: "100%" }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default HourlyActiveIPsChart;
